// @flow
import React, { Component, Fragment } from "react";
import {
    Embed,
    Grid,
    Segment,
    Header,
    Popup,
    Button,
    Icon,
    List,
} from "semantic-ui-react";
import { Loading, Knowledge, KeyFigures } from "components";
import {
    isEmptyEveryObjects,
    numberFormat,
    getKeyFiguresYears,
    formatAddress,
} from "tools";
import { leadersRoles } from "constantes/leaders";
import "./Company.scss";
import { LocalStorage } from "services";

type Props = {
    consumers: any,
    location: any,
    history: any,
    match: any,
};

type State = {
    active: boolean,
    loading: boolean,
    siret: number,
    zoom: number,
    company: any,
    loadingKnowledge: boolean,
    uid?: string,
    organizationId?: string,
    issuer?: string,
    modal: boolean,
};

const paths = {
    redirect: "/recherche/entreprises",
};

const uri = "https://maps.google.com/maps?q=";

/**
 * Company
 * @author Tomasz tpr@deltacode.fr
 * @memberof Containers
 * @extends {React.Component}
 * @description Company container
 */
class Company extends Component<Props, State> {
    /**
     * @constructor
     * @param { Object } props Props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            active: false,
            loading: false,
            siret: 0,
            zoom: 15,
            company: {},
            loadingKnowledge: false,
            modal: false,
        };
    }

    async componentDidMount() {
        /**
         * @instance
         * @async
         * @memberof Containers.Company
         * @method componentDidMount
         * @return { Void }
         */
        const authorizedParts = await LocalStorage.getItem("authorizedParts");
        const uid = await LocalStorage.getItem("uid");
        const organizationId = await LocalStorage.getItem("organizationId");
        const issuer = await LocalStorage.getItem("issuer");
        await this.setState({
            authorizedParts: authorizedParts,
            uid: uid,
            organizationId: organizationId,
            issuer: issuer,
        });
        organizationId && (await this.getStatus());
        if (!this.props.location.state) {
            this.props.history.push(paths.redirect);
        } else {
            try {
                const siret = this.props.location.state.id;
                this.setState({
                    siret: siret,
                });
                let company;
                let rne = null;
                const { companies } = this.props.consumers;
                const localCompanies = await companies.getLocalCompanies();
                if (!localCompanies.length) {
                    const response = await companies.getCompany(siret);
                    company = response;
                } else {
                    const localCompanie = localCompanies.find(
                        (item) => item.siret === siret
                    );
                    if (!localCompanie) {
                        await companies.clear(["companies"]);
                        const response = await companies.getCompany(siret);
                        company = response;
                    } else {
                        company = localCompanie;
                    }
                }

                if (company && !company.uniteLegale.identifiantAssociation) {
                    try {
                        const response = await companies.getRne(
                            siret.slice(0, -5)
                        );
                        rne = response;
                    } catch (error) { }
                }

                this.setState({
                    loading: true,
                    company: { ...company, ...(rne && { rne: rne }) },
                });
            } catch (error) { }
        }
    }
    getStatus = async () => {
        /**
         * @instance
         * @async
         * @method getStatus
         * @memberof Components.WithRouterHeader
         * @description Get favorit status
         * @return { Void }
         */
        const { favorites } = this.props.consumers;
        if (this.props.history.location.state) {
            const { scope } = this.props.location.state;
            try {
                const id = this.props.location.state.id;
                const active = await favorites.inFavorites(scope, id);
                await this.setState({
                    error: false,
                    active: active,
                });
            } catch (error) {
                await this.setState({
                    error: true,
                });
            }
        } else {
            await this.setState({
                active: false,
            });
        }
    };

    handleSearchKnowledge = (company: any) => async (event: any) => {
        /**
         * @instance
         * @async
         * @method handleSearchKnowledge
         * @memberof Containers.Companies
         * @description Search company data
         * @return { Void }
         */
        event.preventDefault();
        if (!company.knowledge) {
            try {
                this.setState({
                    loadingKnowledge: true,
                });
                const { companies } = this.props.consumers;
                const localCompanies = await companies.getLocalCompanies();
                const etablissement = company.uniteLegale.denomination
                    ? company.uniteLegale.denomination
                    : `${company.uniteLegale.nom} ${company.uniteLegale.prenom1}`;
                const response = await companies.getKnowledge(
                    etablissement,
                    `${company.geoAdresse} ${company.adresse.codePostal} ${company.adresse.libelleCommune}`,
                    company.siret
                );

                this.setState({
                    company: { ...company, knowledge: response },
                    loadingKnowledge: false,
                });
                await companies.setLocalCompanies(
                    companies.updateCompanies(
                        localCompanies,
                        company.siret,
                        response
                    )
                );
            } catch (error) { }
        }
    };

    handleToogleFavorits = async () => {
        /**
         * @instance
         * @async
         * @method handleToogleFavorits
         * @memberof Components.WithRouterHeader
         * @description Update favorit status
         * @return { Void }
         */
        const { favorites } = this.props.consumers;
        const data = {
            id: this.props.location.state.id,
            idcc: this.props.location.state.idcc,
            title: this.props.location.state.title,
            description: this.props.location.state.description,
        };
        const { scope } = this.props.location.state;
        await this.setState({
            active: !this.state.active,
        });
        await favorites.toogleFavorites(scope, data);
    };

    render() {
        /**
         * @instance
         * @method render
         * @memberof Containers.Company
         * @return { String } JSX
         */
        const { loading, company, zoom, loadingKnowledge, uid, organizationId, issuer, active } = this.state;

        if (company && !loading) {
            return (
                <Grid className="Company">
                    <Grid.Row>
                        <Loading title="Chargement" />
                    </Grid.Row>
                </Grid>
            );
        } else {
            return (
                <Fragment>
                    <Grid className="Company">
                        <Grid.Row>
                            <Grid.Column>
                                <Embed
                                    active={true}
                                    url={`${uri}${formatAddress(
                                        company.adresse
                                    )}&t=&z=${zoom}&ie=UTF8&iwloc=&output=embed`}
                                ></Embed>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Grid centered>
                        <Grid.Column mobile={16} computer={10}>
                            <Segment.Group>
                                <Segment>
                                    <Header
                                        style={{
                                            marginBottom: "0.2em",
                                            marginTop: "1rem",
                                        }}
                                        as="h2"
                                        textAlign="center"
                                        className="color-default company-name"
                                    >
                                        {company.uniteLegale.denomination
                                            ? company.uniteLegale.denomination
                                            : `${company.uniteLegale.nom} ${company.uniteLegale.prenom1}`}
                                    </Header>
                                    <Header
                                        style={{ margin: "0 0 1em 0" }}
                                        as="h4"
                                        textAlign="center"
                                    >
                                        {formatAddress(company.adresse)}
                                    </Header>
                                    <Popup
                                        wide="very"
                                        hoverable
                                        disabled={!company.rne}
                                        position="top center"
                                        content={
                                            <List size="small" relaxed divided>
                                                {company &&
                                                    company.rne &&
                                                    company.rne.typePersonne ===
                                                    "P" && (
                                                        <List.Item>
                                                            <List.Content>
                                                                <List.Header>
                                                                    {company.rne
                                                                        .identite &&
                                                                        company.rne
                                                                            .identite
                                                                            .entrepreneur &&
                                                                        company.rne
                                                                            .identite
                                                                            .entrepreneur
                                                                            .descriptionPersonne &&
                                                                        company.rne
                                                                            .identite
                                                                            .entrepreneur
                                                                            .descriptionPersonne
                                                                            .nom &&
                                                                        company.rne
                                                                            .identite
                                                                            .entrepreneur
                                                                            .descriptionPersonne
                                                                            .prenoms
                                                                        ? `${company
                                                                            .rne
                                                                            .identite
                                                                            .entrepreneur
                                                                            .descriptionPersonne
                                                                            .nom
                                                                        } ${company.rne.identite.entrepreneur.descriptionPersonne.prenoms.join(
                                                                            ","
                                                                        )}`
                                                                        : "Nom inconnu"}
                                                                </List.Header>
                                                            </List.Content>
                                                        </List.Item>
                                                    )}
                                                {company &&
                                                    company.rne &&
                                                    company.rne.typePersonne !==
                                                    "P" &&
                                                    company.rne.composition &&
                                                    company.rne.composition
                                                        .pouvoirs &&
                                                    company.rne.composition.pouvoirs.map(
                                                        (
                                                            representant,
                                                            index
                                                        ) => (
                                                            <List.Item
                                                                key={index}
                                                            >
                                                                <List.Content>
                                                                    <List.Header>
                                                                        {" "}
                                                                        {representant.typeDePersonne &&
                                                                            representant.typeDePersonne ===
                                                                            "ENTREPRISE"
                                                                            ? representant.entreprise &&
                                                                                representant
                                                                                    .entreprise
                                                                                    .denomination
                                                                                ? representant
                                                                                    .entreprise
                                                                                    .denomination
                                                                                : "Nom inconnu"
                                                                            : representant.individu &&
                                                                                representant
                                                                                    .individu
                                                                                    .descriptionPersonne &&
                                                                                representant
                                                                                    .individu
                                                                                    .descriptionPersonne
                                                                                    .nom &&
                                                                                representant
                                                                                    .individu
                                                                                    .descriptionPersonne
                                                                                    .prenoms
                                                                                ? `${representant
                                                                                    .individu
                                                                                    .descriptionPersonne
                                                                                    .nom
                                                                                } ${representant.individu.descriptionPersonne.prenoms.join(
                                                                                    ","
                                                                                )}`
                                                                                : "Nom inconnu"}
                                                                    </List.Header>{" "}
                                                                    <List.Description>
                                                                        {representant.roleEntreprise &&
                                                                            leadersRoles[
                                                                            representant
                                                                                .roleEntreprise
                                                                            ]
                                                                            ? leadersRoles[
                                                                            representant
                                                                                .roleEntreprise
                                                                            ]
                                                                            : "Rôle inconnu"}{" "}
                                                                        {representant.typeDePersonne && (
                                                                            <>
                                                                                (
                                                                                {
                                                                                    representant.typeDePersonne
                                                                                }

                                                                                )
                                                                            </>
                                                                        )}
                                                                    </List.Description>
                                                                </List.Content>
                                                            </List.Item>
                                                        )
                                                    )}
                                            </List>
                                        }
                                        trigger={
                                            <Button
                                                disabled={!company.rne}
                                                basic={company.rne}
                                                style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "110px",
                                                }}
                                            >
                                                Dirigeants
                                            </Button>
                                        }
                                    />

                                    {loadingKnowledge ? (
                                        <Button
                                            basic
                                            icon
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "60px",
                                            }}
                                        >
                                            <Icon
                                                color="grey"
                                                loading
                                                name="spinner"
                                            />
                                        </Button>
                                    ) : company.hasOwnProperty("knowledge") ? (
                                        <Popup
                                            hoverable
                                            position="top center"
                                            content={
                                                <Knowledge data={company} />
                                            }
                                            trigger={
                                                <Button
                                                    style={{
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "60px",
                                                    }}
                                                    icon="address card"
                                                />
                                            }
                                        />
                                    ) : (
                                        <Button
                                            basic
                                            icon
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "60px",
                                            }}
                                            active={
                                                company.knowledge ? true : false
                                            }
                                            onClick={this.handleSearchKnowledge(
                                                company
                                            )}
                                        >
                                            <Icon name="search" />
                                        </Button>
                                    )}
                                    {uid && organizationId && issuer === "hub" && (
                                        <div
                                            style={{
                                                textAlign: "right",
                                                paddingTop: "1em",
                                            }}
                                        >
                                            <Button circular icon style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "10px",
                                                }}>
                                                <Icon
                                                    onClick={this.handleToogleFavorits}
                                                    name="heart"
                                                    color={active ? "red" : "grey"}
                                                />{" "}
                                            </Button>
                                        </div>
                                    )}
                                    <Grid>
                                        <Grid.Row divided>
                                            <Grid.Column
                                                mobile={16}
                                                tablet={8}
                                                computer={8}
                                            >
                                                <Header
                                                    as="h5"
                                                    textAlign="center"
                                                >
                                                    Catégorie :{" "}
                                                    <strong>
                                                        {company.uniteLegale
                                                            .natureJuridique &&
                                                            company.uniteLegale
                                                                .natureJuridique}
                                                    </strong>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column
                                                mobile={16}
                                                tablet={8}
                                                computer={8}
                                            >
                                                <Header
                                                    as="h5"
                                                    textAlign="center"
                                                >
                                                    Activité :{" "}
                                                    <strong>
                                                        {
                                                            company
                                                                .etablissement
                                                                .classe
                                                        }{" "}
                                                        {company.etablissement
                                                            .activitePrincipaleAPE &&
                                                            `(${company.etablissement.activitePrincipaleAPE})`}
                                                    </strong>
                                                </Header>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                                <Segment.Group horizontal>
                                    <Segment textAlign="center">
                                        Siret
                                        <br />
                                        <strong>
                                            {company.siret
                                                ? company.siret
                                                : "inconnu"}{" "}
                                        </strong>
                                    </Segment>
                                    <Segment textAlign="center">
                                        Création <br />
                                        <strong>
                                            {company.dateCreation
                                                ? company.dateCreation
                                                : "inconnue"}
                                        </strong>
                                    </Segment>
                                    <Segment textAlign="center">
                                        Effectif
                                        <br />
                                        <strong>
                                            {company.uniteLegale
                                                .trancheEffectifsLabel
                                                ? company.uniteLegale
                                                    .trancheEffectifsLabel
                                                : "inconnu"}
                                        </strong>
                                    </Segment>
                                    <Segment textAlign="center">
                                        Finances
                                        <br />
                                        <strong>
                                            Chiffre d'affaires{" "}
                                            {getKeyFiguresYears().n1} :{" "}
                                            {company.keyFigures &&
                                                company.keyFigures[
                                                `chiffre${getKeyFiguresYears().n1
                                                }`
                                                ] &&
                                                company.keyFigures[
                                                    `chiffre${getKeyFiguresYears().n1
                                                    }`
                                                ].ca
                                                ? Number.isNaN(
                                                    Number(
                                                        company.keyFigures[
                                                            `chiffre${getKeyFiguresYears()
                                                                .n1
                                                            }`
                                                        ].ca
                                                    )
                                                )
                                                    ? company.keyFigures[
                                                        `chiffre${getKeyFiguresYears()
                                                            .n1
                                                        }`
                                                    ].ca
                                                    : numberFormat(
                                                        company.keyFigures[
                                                            `chiffre${getKeyFiguresYears()
                                                                .n1
                                                            }`
                                                        ].ca
                                                    )
                                                : "inconnu"}
                                        </strong>
                                        {company.keyFigures &&
                                            isEmptyEveryObjects(
                                                [
                                                    `chiffre${getKeyFiguresYears().n1
                                                    }`,
                                                    `chiffre${getKeyFiguresYears().n2
                                                    }`,
                                                    `chiffre${getKeyFiguresYears().n3
                                                    }`,
                                                ],
                                                company.keyFigures
                                            ) ? (
                                            <KeyFigures company={company} />
                                        ) : null}
                                    </Segment>
                                </Segment.Group>
                            </Segment.Group>
                            <br />
                            <br />
                            <br />
                        </Grid.Column>
                    </Grid>
                </Fragment>
            );
        }
    }
}

export { Company };
